module.exports = __webpack_public_path__ + "0bbb5a7f2bf87542162ca18326cebbcc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/windmill.png
// module id = 587
// module chunks = 0